import React from "react";
// icon
import { IconShoppingBag, IconUser } from "@tabler/icons-react";
// component
import AgentProfile from "../../pages/agent/profile/agentProfile.tsx";
import CreateOrder from "../../pages/agent/orders/createOrder.tsx";
import Orders from "../../pages/agent/orders/orders.tsx";


export const AgentRoutes: any = {
    agent: [
        {
            label: 'آپدیت پروفایل',
            address: '/agent/panel',
            component: <AgentProfile />,
            icon: <IconUser
                size={20}
                className="ms-2 admin-menu-item-svg vertical-td" />
            ,
            items: [
                {
                    label: 'پروفایل',
                    address: '/agent/panel',
                    show: true,
                },
            ]
        },
        {
            label: 'سفارشات',
            address: '/agent/panel/orders',
            component: <Orders />,
            icon: <IconShoppingBag
                size={20}
                className="ms-2 admin-menu-item-svg vertical-td" />
            ,
            items: [
                {
                    label: 'سفارشات',
                    address: '/agent/panel/orders',
                    show: true,
                },
                {
                    label: 'ایجاد سفارش',
                    address: '/agent/panel/orders/create',
                    component: <CreateOrder />,
                    show: true,
                },
            ]
        },
    ],
}
